import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiTranslateModule } from '@fcom/ui-translate';
import { IconsModule, UiComponentsModule } from '@fcom/ui-components';

import { DirectiveModule } from '../../directives';
import { PipesModule } from '../../pipes';
import { HeaderBoxesComponent } from './header-boxes.component';

@NgModule({
  imports: [CommonModule, PipesModule, DirectiveModule, UiTranslateModule, IconsModule, UiComponentsModule],
  declarations: [HeaderBoxesComponent],
  exports: [HeaderBoxesComponent],
})
export class HeaderBoxesModule {}
